import { ContentTypeRouteMap } from '@/config/ContentType';

export const generateLinkHref = (contentType: string, slugPath: string): string =>
  slugPath?.includes('http') || !ContentTypeRouteMap[contentType?.toUpperCase()]
    ? slugPath
    : `${ContentTypeRouteMap[contentType?.toUpperCase()]}/${slugPath}`;
